import { createAsyncThunk } from '@reduxjs/toolkit';
import { examApi } from '~/apis/exam';
import { CREATE_EXAM, DELETE_EXAM_BY_ID, GET_EXAM_BY_ID, GET_LIST_EXAM, UPDATE_EXAM } from '~/utils/constants/actionType';
import { IBodyCreateExam, IBodyUpdateExam, IQueryGetExams } from '~/utils/interface/exam';

export const getListExams = createAsyncThunk(GET_LIST_EXAM, async (payload: IQueryGetExams, { rejectWithValue }) => {
  try {
    const res = await examApi.getListExams(payload);
    return res.data.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const createExam = createAsyncThunk(CREATE_EXAM, async (payload: IBodyCreateExam, { rejectWithValue }) => {
  try {
    const res = await examApi.createExam(payload);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updateExam = createAsyncThunk(UPDATE_EXAM, async (payload: { examId: string; body: IBodyUpdateExam }, { rejectWithValue }) => {
    try {
      const res = await examApi.updateExam(payload.examId, payload.body);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getExamById = createAsyncThunk(GET_EXAM_BY_ID, async (examId: string, { rejectWithValue }) => {
  try {
    const res = await examApi.getExamById(examId);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const deleteExamById = createAsyncThunk(DELETE_EXAM_BY_ID, async (examId: string, { rejectWithValue }) => {
  try {
    const res = await examApi.deleteExamById(examId);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});